import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { FilterDisplayContainer } from 'components/FilterDisplayContainer/FilterDisplayContainer';
import { filterMessages } from 'components/Filters/filterMessages';
import { MealPlansFilter } from 'components/Filters/MealPlansFilter';
import { useFiltersForm } from 'hooks/useFiltersForm';
import { isNil, takeLast } from 'ramda';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w111d9u1",
  propsAsIs: false
});
interface Props {
  isActive?: boolean;
}
const filterKeys = ['amenities'];
export const MealsFilterPopover: React.FC<Props> = ({
  isActive = false
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    submitFilters,
    getFilters,
    toggleMultiFilter,
    clearFilters,
    resetFilters,
    trackFilterClick,
    getAppliedFilters
  } = useFiltersForm(filterKeys);
  const {
    amenities
  } = getFilters();
  const appliedFilters = getAppliedFilters().amenities;
  const amenitiesLabel = useMemo((): string => {
    if (isNil(appliedFilters)) return formatMessage(filterMessages.mealPlans);
    if (appliedFilters.length === 1) {
      return formatMessage(filterMessages[appliedFilters[0]]);
    }
    return `${formatMessage(filterMessages[takeLast(1, appliedFilters).toString()])} +${appliedFilters.length - 1}`;
  }, [formatMessage, appliedFilters]);
  return <FilterDisplayContainer dataId="mealPlansFilter" label={amenitiesLabel} title={formatMessage(filterMessages.mealPlans)} isActive={isActive} onClear={clearFilters} onApply={submitFilters} onClose={resetFilters} onPillClick={trackFilterClick}>
      <Wrapper>
        <MealPlansFilter amenities={amenities} onChange={toggleMultiFilter} />
      </Wrapper>
    </FilterDisplayContainer>;
};

require("./MealsFilterPopover.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MealsFilterPopover.tsx");